module.exports = __webpack_public_path__ + "img/data_null.png";